import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import {Flex, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {FormattedMessage, FormattedNumber} from 'react-intl'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
import {OrderContext} from '../order-context'
const PricingDetailsReturnOrder = ({order, selectedItems}) => {
    const {activeReturnShipmentId} = useContext(OrderContext)
    const styles = useMultiStyleConfig('Orders', {
        isReturnFlow: !!activeReturnShipmentId,
    })
    const {currency} = useCurrency()

    const selectedItemsTotal = (() => {
        if (!order?.orderItems || !selectedItems) return 0

        const orderItemsMap = new Map(
            order.orderItems.map((item) => [
                item.Id,
                {
                    totalAmount: item.TotalAmtWithTax ?? item.TotalLineAmountWithTax,
                    quantity: item.Quantity,
                },
            ]),
        )

        return selectedItems.reduce((total, selectedItem) => {
            const orderItem = orderItemsMap.get(selectedItem.id)
            if (!orderItem) return total

            const pricePerUnit = orderItem.totalAmount / orderItem.quantity
            const selectedItemTotal = pricePerUnit * selectedItem.quantity

            return total + selectedItemTotal
        }, 0)
    })()

    if (!order) return

    return (
        <Flex {...styles.priceContainer}>
            {!activeReturnShipmentId && (
                <>
                    <Flex {...styles.priceChild}>
                        <Text {...styles.priceTitle}>
                            <FormattedMessage
                                defaultMessage="Subtotal"
                                id="account_order_detail.label.subtotal"
                            />
                        </Text>
                        <Text {...styles.priceNumber}>
                            <FormattedNumber
                                style="currency"
                                currency={currency}
                                value={order?.subTotal}
                            />
                        </Text>
                    </Flex>
                    <Flex {...styles.priceChild}>
                        <Text {...styles.priceTitle}>
                            <FormattedMessage
                                defaultMessage="Discount"
                                id="account_order_detail.label.discount"
                            />
                        </Text>
                        <Text {...styles.priceNumber}>
                            <FormattedNumber
                                style="currency"
                                currency={currency}
                                value={order?.totalDiscount}
                            />
                        </Text>
                    </Flex>
                    <Flex {...styles.priceChild}>
                        <Text {...styles.priceTitle}>
                            <FormattedMessage
                                defaultMessage="Shipping cost"
                                id="account_order_detail.label.shipping_cost"
                            />
                        </Text>
                        <Text {...styles.priceNumber}>
                            <FormattedNumber
                                style="currency"
                                currency={currency}
                                value={order?.shippingCost}
                            />
                        </Text>
                    </Flex>
                    <Flex {...styles.priceChild}>
                        <Text {...styles.priceTitle}>
                            <FormattedMessage
                                defaultMessage="Taxes"
                                id="account_order_detail.label.taxes"
                            />
                        </Text>
                        <Text {...styles.priceNumber}>
                            <FormattedNumber
                                style="currency"
                                currency={currency}
                                value={order?.totalTax}
                            />
                        </Text>
                    </Flex>
                </>
            )}

            <Flex {...styles.priceChild}>
                <Text {...styles.priceTitle}>
                    <FormattedMessage
                        defaultMessage="Total"
                        id="account_order_detail.label.total"
                    />
                </Text>
                <Text {...styles.priceNumber}>
                    <FormattedNumber
                        style="currency"
                        currency={currency}
                        value={selectedItemsTotal}
                    />
                </Text>
            </Flex>
        </Flex>
    )
}

PricingDetailsReturnOrder.propTypes = {
    order: PropTypes.object,
    selectedItems: PropTypes.array,
}

export default PricingDetailsReturnOrder
